<template>
  <div class="h-full">
    <div class="flex h-full justify-end items-center">
      <vs-dropdown
        style="margin-left: 5px; cursor: pointer"
        vs-custom-content
        vs-trigger-click
      >
        <vs-button
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-more-vertical"
        ></vs-button>

        <vs-dropdown-menu style="min-width: 100px">
        <vs-dropdown-item

            @click="openPreview"
            >Preview</vs-dropdown-item
          >
          <vs-dropdown-item

            @click="openEditView(params.data)"
            >Edit</vs-dropdown-item
          >
          <vs-dropdown-item

            @click="openConfirm(params.data.id, params.data)"
            >Delete</vs-dropdown-item
          >
          <vs-dropdown-item

            @click="sharingQuestion(params.data.id, params.sharedUserList)"
            >Share</vs-dropdown-item
          >

        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
  </div>
</template>

<script>
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import { checkingAssignment } from '../../../../mixins/middleware/checkingAssignment'

export default {
  mixins: [PermissionMiddleware, checkingAssignment],
  name: 'CellRendererAction',
  created () {
    const role_permission = parseInt(localStorage.getItem('role_permission'))
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Question Bank')
    }
  },
  data () {
    return {
      questionApplicationType:'General',
      courseApplicationType: '',
      listingtype: 'course'
    }
  },
  mounted () {
    this.courseApplicationType =
      this.params.colDef.filterParams.courseApplicationType
  },
  methods: {
    openPreview () {
      this.$router.push({
        name: 'Preview QuestionsV2',
        params: {
          assignment_id:this.params.data.id,
          formType: 'Preview',
          type:'Question',
          redirection_from:1,
          assignmentApplicationType: 'General'
        }
      })
    },

    sharingQuestion (id, data) {
      this.params.colDef.filterParams.sharingQuestion(id, data)
    },

    openEditView (editingObject) {
      this.params.colDef.filterParams.openEditView(editingObject)
    },
    openConfirm (id, data) {
      this.params.colDef.filterParams.openConfirm(id, data)
    }
  }
}
</script>
